import { render, staticRenderFns } from "./GetCoupon.vue?vue&type=template&id=4a987583&scoped=true"
import script from "./GetCoupon.vue?vue&type=script&lang=js"
export * from "./GetCoupon.vue?vue&type=script&lang=js"
import style0 from "./GetCoupon.vue?vue&type=style&index=0&id=4a987583&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a987583",
  null
  
)

export default component.exports